import {Injectable} from '@angular/core';
import { Fenetre } from '../data/model/Fenetre';
import { plainToClass } from 'class-transformer';



@Injectable()
export class FenetreService {

  Open: Fenetre[];

  constructor() {
    this.Open = [];
    // test local storage;
  }

  findnames(pop: string) {


    const jsonpopup = JSON.parse(localStorage.getItem('popup'));
    if (jsonpopup === null || jsonpopup === undefined)
    return null;

    const itemIndex = jsonpopup.findIndex(elem => elem === pop);

    if (itemIndex > -1)
    return jsonpopup[itemIndex];
    else
    return null;

  }

  savename(pop: string) {

    let jsonpopup = JSON.parse(localStorage.getItem('popup'));

    if (jsonpopup === null) {
      jsonpopup = [];
      // return;
    }

    const itemIndex = jsonpopup.findIndex(elem => elem === pop);

    if (itemIndex === -1) {
      jsonpopup.push(pop);
      localStorage.setItem('popup', JSON.stringify(jsonpopup));
    }

  }

  removename(pop: string) {

    const jsonpopup = JSON.parse(localStorage.getItem('popup'));

    if (jsonpopup === null)
    return;

    const itemIndex = jsonpopup.findIndex(elem => elem === pop);
    jsonpopup.splice(itemIndex, 1);
    localStorage.setItem('popup', JSON.stringify(jsonpopup));

  }

}
